export const DrawerStyle = {
  height: '100%',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  display: 'flex',
  alignItems: 'center',
}
